module.exports = __webpack_public_path__ + "static/media/farmer.aa826e35.svg";